<div class="JinniModal" *ngIf="visible" [ngClass]="{'active' : modalIsVisible, 'notActive': !modalIsVisible}">
    <div class="modal">
        <ng-content></ng-content>
    </div>
</div>